// Vẽ icon máy ảnh (vector) — thân bo góc, ô ngắm hình thang, ống kính 2 lớp, đèn flash
export const drawCameraIcon = (ctx, x, y, s) => {
    ctx.save()
    const r = s * 0.16

    // ô ngắm (hình thang) phía trên-trái
    const bumpW = s * 0.36
    const bumpH = s * 0.22
    const bumpX = x + s * 0.14
    ctx.fillStyle = 'black'
    ctx.beginPath()
    ctx.moveTo(bumpX, y + bumpH)
    ctx.lineTo(bumpX + bumpW * 0.2, y)
    ctx.lineTo(bumpX + bumpW * 0.8, y)
    ctx.lineTo(bumpX + bumpW, y + bumpH)
    ctx.closePath()
    ctx.fill()

    // thân máy (bo góc)
    const bodyY = y + bumpH * 0.7
    const bodyH = (y + s) - bodyY
    ctx.fillStyle = 'black'
    ctx.beginPath()
    ctx.moveTo(x + r, bodyY)
    ctx.arcTo(x + s, bodyY, x + s, bodyY + bodyH, r)
    ctx.arcTo(x + s, bodyY + bodyH, x, bodyY + bodyH, r)
    ctx.arcTo(x, bodyY + bodyH, x, bodyY, r)
    ctx.arcTo(x, bodyY, x + s, bodyY, r)
    ctx.closePath()
    ctx.fill()

    // đèn flash (lỗ trắng góc trên-phải thân)
    ctx.fillStyle = 'white'
    ctx.beginPath()
    ctx.arc(x + s * 0.82, bodyY + s * 0.13, s * 0.055, 0, Math.PI * 2)
    ctx.fill()

    // ống kính: đĩa trắng + vành đen + tâm đen
    const cx = x + s / 2
    const cy = bodyY + bodyH / 2 + s * 0.02
    ctx.fillStyle = 'white'
    ctx.beginPath()
    ctx.arc(cx, cy, s * 0.25, 0, Math.PI * 2)
    ctx.fill()
    ctx.lineWidth = Math.max(1, s * 0.07)
    ctx.strokeStyle = 'black'
    ctx.beginPath()
    ctx.arc(cx, cy, s * 0.25, 0, Math.PI * 2)
    ctx.stroke()
    ctx.fillStyle = 'black'
    ctx.beginPath()
    ctx.arc(cx, cy, s * 0.11, 0, Math.PI * 2)
    ctx.fill()

    ctx.restore()
}
